module.exports = __webpack_public_path__ + "static/home_back4-ed2f3194fbee1257accce7be2445a1c8.png";